<template>
  <div class="data">
    <section class="card">
      <header class="card__head">
        <span class="card__icon"><span class="mdi mdi-microsoft-excel"></span></span>
        <div>
          <h2 class="card__title">Exportar mis datos</h2>
          <p class="card__sub">Descarga una copia en Excel de la información actual de tu parque.</p>
        </div>
      </header>

      <ul class="chips">
        <li v-for="item in INCLUDED" :key="item.label" class="chip">
          <span class="mdi" :class="item.icon"></span>{{ item.label }}
        </li>
      </ul>

      <p class="note">
        Es una foto de tus datos al momento de descargar: no se actualiza sola. El archivo trae una hoja por tema, con filtros y fechas en formato de Excel.
      </p>

      <div class="actions">
        <button class="btn" :disabled="busy" @click="onDownload">
          <span class="mdi" :class="busy ? 'mdi-loading spin' : 'mdi-download'"></span>
          {{ busy ? 'Generando archivo…' : 'Descargar Excel' }}
        </button>
        <span v-if="doneName" class="ok"><span class="mdi mdi-check-circle"></span> Descargado: {{ doneName }}</span>
      </div>
      <p v-if="error" class="err">{{ error }}</p>
    </section>

    <aside class="warn">
      <span class="mdi mdi-shield-lock-outline"></span>
      <p>
        El archivo contiene información financiera y datos de contacto de tus inquilinos. Guárdalo en un lugar seguro y no lo compartas por canales abiertos.
        Cada exportación queda registrada.
      </p>
    </aside>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { downloadParkExport } from '@/services/parkExport'

const props = defineProps({ parkId: { type: String, required: true } })

const INCLUDED = [
  { label: 'Naves', icon: 'mdi-warehouse' },
  { label: 'Inquilinos', icon: 'mdi-domain' },
  { label: 'Contratos', icon: 'mdi-file-sign' },
  { label: 'Cargos de cobranza', icon: 'mdi-cash-multiple' },
  { label: 'Pagos', icon: 'mdi-cash-check' },
  { label: 'Gastos', icon: 'mdi-receipt-text-outline' },
]

const busy = ref(false)
const error = ref('')
const doneName = ref('')

async function onDownload() {
  if (busy.value) return
  busy.value = true
  error.value = ''
  doneName.value = ''
  try {
    doneName.value = await downloadParkExport(props.parkId)
  } catch (err) {
    error.value = err.message
  } finally {
    busy.value = false
  }
}
</script>

<style scoped>
.data { display: flex; flex-direction: column; gap: 16px; max-width: 760px; margin: 0 auto; padding-bottom: 32px; }
.card { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 22px 24px; }
.card__head { display: flex; align-items: flex-start; gap: 14px; margin-bottom: 18px; }
.card__icon { width: 40px; height: 40px; border-radius: 10px; background: rgba(16, 185, 129, 0.12); color: #10b981; display: flex; align-items: center; justify-content: center; font-size: 22px; flex-shrink: 0; }
.card__title { margin: 0; font: 600 16px Inter, sans-serif; color: #1e3a5f; }
.card__sub { margin: 3px 0 0; font: 400 13px/1.5 Inter, sans-serif; color: #64748b; }
.chips { list-style: none; margin: 0 0 14px; padding: 0; display: flex; flex-wrap: wrap; gap: 8px; }
.chip { display: inline-flex; align-items: center; gap: 6px; padding: 5px 11px; border-radius: 16px; background: #f1f5f9; color: #1e3a5f; font: 400 12px Inter, sans-serif; }
.chip .mdi { color: #94a3b8; font-size: 14px; }
.note { margin: 0 0 18px; font: 400 12px/1.6 Inter, sans-serif; color: #64748b; }
.actions { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
.btn { display: inline-flex; align-items: center; gap: 8px; height: 38px; padding: 0 18px; border: none; border-radius: 8px; background: #3b82f6; color: #fff; font: 500 13px Inter, sans-serif; cursor: pointer; }
.btn:hover:not(:disabled) { background: #2563eb; }
.btn:disabled { opacity: 0.65; cursor: default; }
.spin { animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.ok { display: inline-flex; align-items: center; gap: 6px; font: 400 12px Inter, sans-serif; color: #047857; word-break: break-all; }
.err { margin: 12px 0 0; font: 400 12px Inter, sans-serif; color: #b91c1c; }
.warn { display: flex; gap: 12px; padding: 12px 16px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 10px; }
.warn .mdi { color: #d97706; font-size: 20px; flex-shrink: 0; }
.warn p { margin: 0; font: 400 12px/1.6 Inter, sans-serif; color: #92400e; }
</style>